import { render } from "./AddBlock.vue?vue&type=template&id=5faf62ca&scoped=true"
import script from "./AddBlock.vue?vue&type=script&lang=js"
export * from "./AddBlock.vue?vue&type=script&lang=js"

import "./AddBlock.vue?vue&type=style&index=0&id=5faf62ca&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faf62ca"]])

export default __exports__